module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "a12_text"
    }
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("Diagrams in Text")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("A. Compass, Blue Pendant, and 9 Pendant turns")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("B. The 5th Battle Squadron’s turn to starboard on the run to the north")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("C. Deployment on the starboard wing")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("D. Scheer’s alternative routes home")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("E. Sketch showing handing room in a British ship")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a70353f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/12_text.vue
// module id = 90
// module chunks = 0